import HasRole from "modules/5_view_helpers/HasRole";
import { createCustomFormLinks, createMenuItems } from "../helpers";

const getTrainingNav = (training_custom_forms, training_menus) => {
  const TrainingRoles = HasRole({ category: "Training" });

  const TrainingBookingsRoles = HasRole({
    resource_type: "Training::Bookings",
  });

  const TrainingCompaniesRoles = HasRole({
    resource_type: "Training::Company",
  });
  const TrainingCoursesRoles = HasRole({
    resource_type: "Training::Course",
  });
  const TrainingCourseCategoryRoles = HasRole({
    resource_type: "Training::CourseCategory",
  });
  const TrainingQualificationStatusRoles = HasRole({
    resource_type: "Training::QualificationStatus",
  });
  const TraniningNZQANumbersRoles = HasRole({
    resource_type: "Training::NzqaNumber",
  });

  if (TrainingRoles || _.isNotEmpty(training_custom_forms) || _.isNotEmpty(training_menus)) {
    let trainingMenu = {
      icon: "fa fa-graduation-cap",
      label: "Training",
      content: [],
    };
    trainingMenu.content.push({ label: "Dashboard", to: "/training/dashboard" });

    if (TrainingBookingsRoles) {
      trainingMenu.content.push({ label: "Bookings", to: "/training/bookings" });
    }

    if (TrainingCoursesRoles) {
      trainingMenu.content.push({ label: "Courses", to: "/training/courses" });
    }
    if (TrainingCourseCategoryRoles) {
      trainingMenu.content.push({
        label: "Course Categories",
        to: "/training/course_categories",
      });
    }
    if (TrainingCompaniesRoles) {
      trainingMenu.content.push({ label: "Companies", to: "/training/companies" });
    }
    if (TraniningNZQANumbersRoles) {
      trainingMenu.content.push({ label: "NZQA Numbers", to: "/training/nzqa_numbers" });
    }

    trainingMenu.content = _.concat(
      trainingMenu?.content,
      createCustomFormLinks(training_custom_forms),
      createMenuItems(training_menus)
    );

    return trainingMenu;
  }
};

export default getTrainingNav;
